import { jsx as _jsx } from "react/jsx-runtime";
import { getJourneyState, JourneyStatus, logger } from '@vista/omnichannel-components-domain';
import { observer } from 'mobx-react';
import { useJourneyContext } from '../../../context/journey/hooks/use-journey-context';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { JourneyActionButtonAppleWallet } from './subcomponents/apple-wallet/apple-wallet';
import { JourneyActionButtonBase } from './subcomponents/base';
import { JourneyActionButtonGooglePay } from './subcomponents/google-pay/google-pay';
import { JourneyActionButtonSkeleton } from './subcomponents/skeleton';
import { JourneyActionButtonSwapSeats } from './subcomponents/swap-seats/swap-seats';
import { defaultJourneyActionButtonPropsProvider, journeyActionButtonPropsValidator } from './types/props';
import { JourneyActionButtonType } from './types/type';
import { isButtonSupported } from './utils/is-button-supported';
export const JourneyActionButton = observer(props => {
    const { journey } = useJourneyContext();
    if (!isButtonSupported(props.type))
        return null;
    if (!journey)
        return _jsx(JourneyActionButtonSkeleton, { type: props.type });
    // Do not show journey action button if the journey isn't active.
    if (journey && getJourneyState(journey).status !== JourneyStatus.Active)
        return null;
    switch (props.type) {
        case JourneyActionButtonType.AppleWallet:
            return _jsx(JourneyActionButtonAppleWallet, Object.assign({}, props));
        case JourneyActionButtonType.GooglePay:
            return _jsx(JourneyActionButtonGooglePay, Object.assign({}, props));
        case JourneyActionButtonType.SwapSeats:
            return _jsx(JourneyActionButtonSwapSeats, Object.assign({}, props));
        case JourneyActionButtonType.Custom:
            return _jsx(JourneyActionButtonBase, Object.assign({}, props));
        default:
            logger.error(`Unsupported JourneyActionButtonType ${props.type}.`);
            return null;
    }
});
JourneyActionButton.displayName = 'JourneyActionButton';
/**
 * The **Journey Action Button** component will render a single button depending on the `type` prop value.
 */
export const JourneyActionButtonComponent = withComponentWrapper(JourneyActionButton, defaultJourneyActionButtonPropsProvider, journeyActionButtonPropsValidator);
